<template>
    <div class=" contact-info-container">
        <template v-if="isKp">
            <div class="pointer mr-10 flex site-service" @click="toOuterLink(serviceDeskUrl)">
                <img class="icon-pic mr-5" src="@/assets/img/Icon-OAK.png">
                <div class="font-bold">{{ $t('newsMgt.serviceDesk') }} <br/>(Roll-forward)</div>
            </div>
            
            <div class="pointer flex contact-us">
                <img class="icon-pic mr-5" src="@/assets/img/icon-contact.png">
                <a target="_top" href="mailto:cnfmkpmgclicbt@kpmg.com">{{ $t('newsMgt.contactTeam') }}</a>
            </div>
        </template>
    </div>
</template>
<script>
import SvgIcon from "@/components/svgIcon/index";

export default{
    name:'ContentTopRight',
    props:{
        isKp:{
            type:Boolean,
            default:()=>true
        }
    },
    components:{ SvgIcon },
    data(){
        return{
            serviceDeskUrl:'http://cnshaapp103.cn.kworld.kpmg.com/OAK/user/CreateTicketFromProfiles.aspx?ticketType=nonClient'
        }
    },
    mounted(){
    },
    methods:{
        toOuterLink(url){
            if(!url) return
            window.open(url)
        },
    }
}
</script>
<style scoped>
.font-bold{
    font-weight: bold;
}

.contact-info-container{
    color: white;
    font-size: 12px;
    /* position: absolute;
    right: 0;
    top:0; */
    display: inline-flex;
    height: 62px;
    margin-top: 10px;
}


.icon-pic{
    width: 20px;
    height: 20px;
}
.site-service{
    /* height: 40px; */
    padding: 10px 5px;
    background: url('~@/assets/img/bg-Introduction.png') no-repeat;
    background-size: cover;
    cursor: pointer;
    border-radius: 4px;
    width: 180px;
    align-items: center;
}

.contact-us{
    /* height: 40px; */
    padding: 10px 5px;
    background: url('~@/assets/img/bg-contact.png') no-repeat;
    background-size: cover;
    border-radius: 4px;
    width: 180px;
    align-items: center;
}

.contact-us a {
    color: white;
    font-weight: bold;
}
</style>